var map = {
	"./404-bg.png": 34,
	"./STALIZ.svg": 0,
	"./about.jpg": 19,
	"./agreement-arrow.svg": 35,
	"./articles1.jpg": 20,
	"./articles2.jpg": 4,
	"./breadcrumb.svg": 36,
	"./card1.png": 21,
	"./card2.png": 22,
	"./cardGallery1.jpg": 23,
	"./cardGallery2.jpg": 24,
	"./cardGallery3.jpg": 9,
	"./cardGallery4.jpg": 10,
	"./cardGallery5.jpg": 37,
	"./catalogDoor1.png": 2,
	"./catalogDoor2.png": 3,
	"./facing.jpg": 25,
	"./facing1.jpg": 26,
	"./form-arrow.svg": 38,
	"./logo.png": 1,
	"./mainBanner-mob.png": 39,
	"./mainBanner.png": 40,
	"./product1.jpg": 15,
	"./product2.jpg": 16,
	"./product3.jpg": 17,
	"./product4.jpg": 18,
	"./services1.jpg": 12,
	"./services2.jpg": 13,
	"./services3.jpg": 14,
	"./services4.jpg": 5,
	"./services5.jpg": 41,
	"./slider1.jpg": 6,
	"./slider2.jpg": 7,
	"./slider3.jpg": 8,
	"./staliz-bg-menu.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;